<template>
  <div style="height: 100%">
    <!--机房情况-->
    <label style="margin-top: 15px;font-weight: bold;margin-left: 30px;">空间情况</label>
    <el-row style="height: 25%">
      <el-col :span="6">
        <el-col :span="18" style="margin-left: 20%">
          <div class="summary roomSummary pointer"  @touchstart="toRouter('/overview')"  @click="toRouter('/overview')">
                <span class="summaryData"><span
                  id="gatewayCount">{{ summary.spaceCount ? summary.spaceCount : 0 }}</span><span
                  style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;">
            空间总数
          </div>
        </el-col>
      </el-col>
      <el-col :span="6">
        <el-col :span="18" style="margin-left: 15%">
          <div class="summary alarmSummary pointer"  @touchstart="spaceClick"  @click="spaceClick">
                <span class="summaryData "><span
                  id="gatewayAlarm">{{ summary.spaceAlarmCount ? summary.spaceAlarmCount : 0 }}</span><span
                  style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;">
            空间告警
          </div>
        </el-col>
      </el-col>
      <el-col :span="6">
        <el-col :span="18" style="margin-left: 10%">
          <div class="summary deviceSummary pointer"  @touchstart="toRouter('/device-list','list')" @click="toRouter('/device-list','list')">
              <span class="summaryData"><span id="deviceCount">{{
                  summary.deviceCount ? summary.deviceCount : 0
                }}</span><span
                style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;text-align: left;">
            设备总数
          </div>
        </el-col>
      </el-col>
      <el-col :span="6">
        <el-col :span="18" style="margin-left: 5%">
          <div class="summary alarmSummary pointer"  @touchstart="toRouter('/realTime-alarm')"  @click="toRouter('/realTime-alarm')">
              <span class="summaryData"><span id="deviceAlarm">{{
                  summary.deviceAlarm ? summary.deviceAlarm : 0
                }}</span><span
                style="color: #fff;font-size: 1rem">个</span></span>
          </div>
          <div style="color: #fff;font-size: 1rem;padding-left: 10px;text-align: left;">
            设备告警
          </div>
        </el-col>
      </el-col>
    </el-row>
    <!--当前状态总览-->
    <el-row style="height: 50%;margin-top: 4%">
      <bar-chart ref="barChart" style="height: 100%" :data="data"></bar-chart>
    </el-row>
  </div>
</template>

<script>
import BarChart from "@/components/echarts/BarChart";
import {countDeviceStatusByTag, getDeviceSummary} from '@/network/device-info';
import platenLayoutEdit from '@/mixins/platenLayoutEdit'

export default {
  name: "RoomSituation",
  mixins: [platenLayoutEdit],
  components: {BarChart},
  data() {
    return {
      summary: {},
      data: null,
    }
  },
  created() {
    this.getData();
    this.$store.dispatch('addIntervalObj', {'getRoomSituation:5000': this.getData})
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getRoomSituation')
  },
  methods: {
    getData() {
      countDeviceStatusByTag().then(res => {
        if (res.code === 0) {
          this.data = res.data;
          this.data.statusName = ["正常", "告警", "在线", "离线"];
        }
      })
      getDeviceSummary().then(res => {
        if (res.code === 0) {
          this.summary = res.data
        }
      })
    },
    spaceClick() {
      if (this.isPlatenLayoutEditing) return
      if(!this.summary || this.summary.spaceAlarmCount<=0){
        return;
      }
      // let routeUrl = this.$router.resolve({
      //   path: "/overview",
      //   query: {spaceId: this.summary.spaceIdList[0], spaceName: this.summary.spaceNameList[0]}
      // });
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: "/overview",
        query: {spaceId: this.summary.spaceIdList[0], spaceName: this.summary.spaceNameList[0]}
      })
    },
    toRouter(router,mode){
      if (this.isPlatenLayoutEditing) return
      // let routeUrl = this.$router.resolve({
      //   path: router,
      //   query: {mode: mode}
      // });
      // window.open(routeUrl.href, '_blank')
      this.$router.push({
        path: router,
        query: {mode: mode}
      })
    }
  }
}
</script>

<style scoped>
.summary {
  background-position: 0 50%;
  background-size: contain;
  background-repeat: no-repeat;
  text-align: right;
}

.summaryData {
  line-height: 10vh;
  padding-right: 25%;
  font-size: 1.2rem;
  color: rgba(0, 227, 246, 1);
}

.roomSummary {
  background-image: url('../../assets/images/index/roomSummary.gif');
  margin-top: 5%;
}

.deviceSummary {
  background-image: url('../../assets/images/index/deviceSummary.gif');
  margin-top: 5%;
}

.alarmSummary {
  background-image: url('../../assets/images/index/platen-alarm.gif');
  margin-top: 5%;
  color: rgba(255, 67, 76, 1);
}
</style>
